/**
 * [polecenie właściciela 2026-10-01, projekt „Cykl życia na pasku”] ETAPY PROCEDURY — jedno miejsce kodów, etykiet i zdań.
 *
 * Właściciel: „Totalnie nie rozumiem działania tego mpracownik.krosno.com/admin/procedury-bezpieczenstwo, trzeba to logicznie
 * naprawić”. Każda procedura idzie tą samą drogą: przygotowanie treści → zatwierdzenie zarządu → publikacja i potwierdzenia →
 * pilnowanie. Etap, „na kogo czeka” i „co dalej” LICZY SERWER (pola `etap`, `czekaNa`, `czekaNaTermin`, `nastepnyKrok`,
 * `zalegleObowiazki` w wierszu listy i w szczegółach) — tu są wyłącznie słowa na ekran i drobne pomocniki odczytu.
 *
 * Z tego pliku korzystają: strona /admin/procedury-bezpieczenstwo (pasek etapów, lista), okno procedury (kropki etapów)
 * i Mój Dział → Procedury (skrócony pasek działu). Zmieniasz słowo — zmienia się na wszystkich trzech ekranach naraz.
 */

/** Adres modułu „Procedury i bezpieczeństwo” — kafelek panelu administracyjnego (jedyny adres redakcji). */
export const SCIEZKA_MODULU_PROCEDUR = "/admin/procedury-bezpieczenstwo";

/** Cztery etapy w kolejności drogi dokumentu. `zdanie` stoi w nagłówku sekcji listy; `coTuRobisz` — w panelu etapu. */
export const ETAPY = Object.freeze([
    Object.freeze({
        kod: "przygotowanie", numer: 1, etykieta: "Przygotowanie",
        zdanie: "piszesz treść procedury w konfiguratorze",
        coTuRobisz: "przygotowujesz treść. Piszesz na kartce obok; tutaj wczytasz gotowy dokument albo obejrzysz wcześniejsze wersje.",
    }),
    Object.freeze({
        kod: "zatwierdzenie", numer: 2, etykieta: "Zatwierdzenie zarządu",
        zdanie: "recenzent sprawdza treść, potem głosuje zarząd spółki",
        coTuRobisz: "procedurę najpierw sprawdza recenzent, potem głosuje zarząd spółki. Bez zgody zarządu nie da się jej opublikować.",
    }),
    Object.freeze({
        kod: "publikacja", numer: 3, etykieta: "Publikacja i potwierdzenia",
        zdanie: "procedura obowiązuje, pracownicy potwierdzają",
        coTuRobisz: "udostępniasz procedurę pracownikom i pilnujesz, żeby ci, których dotyczy, potwierdzili zapoznanie.",
    }),
    Object.freeze({
        kod: "pilnowanie", numer: 4, etykieta: "Pilnowanie",
        zdanie: "czy treść jest aktualna i czy ludzie jej przestrzegają",
        coTuRobisz: "co jakiś czas sprawdzasz, czy treść jest aktualna i czy ludzie jej przestrzegają.",
    }),
]);

/** Procedura wycofana — poza czterema etapami (archiwum). */
export const ETAP_WYCOFANA = Object.freeze({
    kod: "wycofana", numer: 0, etykieta: "Wycofana",
    zdanie: "procedury, które już nie obowiązują (archiwum)",
    coTuRobisz: "przeglądasz procedury wycofane — zostają w archiwum z całą historią.",
});

const PO_KODZIE = new Map([...ETAPY, ETAP_WYCOFANA].map((e) => [e.kod, e]));

/** Etap po kodzie („pilnowanie”) albo po numerze (4 / „4”); nieznany — null. */
export const etapPoKodzie = (kodLubNumer) => {
    if (kodLubNumer == null || kodLubNumer === "") return null;
    if (PO_KODZIE.has(String(kodLubNumer).toLowerCase())) return PO_KODZIE.get(String(kodLubNumer).toLowerCase());
    const n = Number(kodLubNumer);
    return ETAPY.find((e) => e.numer === n) || null;
};

/** Numer etapu 1–4 (0 = wycofana, null = nieznany). */
export const numerEtapu = (kodLubNumer) => {
    const e = etapPoKodzie(kodLubNumer);
    return e ? e.numer : null;
};

/** Etykieta etapu dla człowieka („Zatwierdzenie zarządu”); nieznany kod — „—”. */
export const etykietaEtapu = (kodLubNumer) => etapPoKodzie(kodLubNumer)?.etykieta || "—";

/**
 * Etap wiersza. Źródło: pole `etap` z serwera. ZAPAS wyłącznie dla odpowiedzi starszego serwera (bez pola `etap` —
 * okno wdrożenia, atrapy testów innych ekranów): ten sam podział co serwer, z pól, które wiersz niósł już wcześniej.
 * Gdy serwer podaje `etap`, zapas nie jest czytany.
 */
export const etapPozycji = (p) => {
    if (!p) return null;
    const zSerwera = etapPoKodzie(p.etap);
    if (zSerwera) return zSerwera.kod;
    if (p.stanPolityki === "wycofana") return "wycofana";
    const obieg = p.etapObiegu;
    if (obieg === "u_recenzenta" || obieg === "czeka_na_zarzad" || obieg === "u_zarzadu" || obieg === "czeka_na_przeglad") return "zatwierdzenie";
    if (p.wersjaRoboczaId || p.stanPolityki === "w_przygotowaniu" || !p.stanPolityki) {
        if (p.stanNajnowszejWersji === "zatwierdzona") return "publikacja";
        return "przygotowanie";
    }
    if (p.stanPolityki === "obowiazuje") {
        if (p.przegladPoTerminie || Number(p.kontroliPoTerminie) > 0 || Number(p.kontroliZblizaSie) > 0 || obieg === "wniosek_o_wycofanie") return "pilnowanie";
        return "publikacja";
    }
    return "przygotowanie";
};

/**
 * Czy procedura czeka TERAZ na oglądającego. Serwer mówi to polem `czekaNaCiebie` (PolitykaWierszDto) i zdaniem `czekaNa`
 * („Na Ciebie: …”). Bez żadnego z nich — nie (front nie zgaduje, czyja jest kolej).
 */
export const czekaNaMnie = (p) => {
    if (!p) return false;
    if (p.czekaNaCiebie === true) return true;
    if (p.czekaNaCiebie === false) return false;
    return typeof p.czekaNa === "string" && /^\s*na ciebie\b/i.test(p.czekaNa);
};

/** Numer etapu, na którym okno procedury ma się otworzyć z „Co dalej”: etap kroku z serwera, inaczej etap wiersza. */
export const etapKroku = (p) => {
    const zKroku = Number(p?.nastepnyKrok?.etap);
    if (zKroku >= 1 && zKroku <= 4) return zKroku;
    const zWiersza = Number(p?.etapNumer);
    if (zWiersza >= 1 && zWiersza <= 4) return zWiersza;
    return numerEtapu(etapPozycji(p)) || null;
};

/** Adres okna procedury w module: `/admin/procedury-bezpieczenstwo?doc=ID(&etap=N)`. */
export const sciezkaProcedury = (id, etap = null) => {
    const q = new URLSearchParams();
    q.set("doc", String(id));
    const n = numerEtapu(etap);
    if (n) q.set("etap", String(n));
    return `${SCIEZKA_MODULU_PROCEDUR}?${q.toString()}`;
};

/**
 * Odmiana rzeczownika po liczbie — trzy formy: dla 1, dla 2–4 (bez 12–14, z 22–24 itd.) i dla pozostałych.
 * odmiana(1, "ustawienie", "ustawienia", "ustawień") → „ustawienie”; 3 → „ustawienia”; 5, 12, 0 → „ustawień”.
 */
export const odmiana = (n, jeden, kilka, wiele) => {
    const x = Math.abs(Number(n) || 0);
    if (x === 1) return jeden;
    const j = x % 10;
    const d = x % 100;
    if (j >= 2 && j <= 4 && !(d >= 12 && d <= 14)) return kilka;
    return wiele;
};

/** Odmiana „procedura” po liczbie: 1 procedura, 2–4 procedury, 5+ procedur (też 12–14 procedur). */
export const slowoProcedura = (n) => odmiana(n, "procedura", "procedury", "procedur");

/** „czeka” / „czekają” po liczbie: 1 czeka, 2–4 czekają, 5+ czeka (jak „5 procedur czeka”). */
export const slowoCzeka = (n) => {
    const x = Math.abs(Number(n) || 0);
    const j = x % 10;
    const d = x % 100;
    return j >= 2 && j <= 4 && !(d >= 12 && d <= 14) ? "czekają" : "czeka";
};

/** „N zaległych potwierdzeń” z poprawną odmianą (1 zaległe potwierdzenie, 2–4 zaległe potwierdzenia, 5+ zaległych potwierdzeń). */
export const opisZaleglych = (n) => {
    const x = Math.abs(Number(n) || 0);
    if (x === 1) return "1 zaległe potwierdzenie";
    const j = x % 10;
    const d = x % 100;
    if (j >= 2 && j <= 4 && !(d >= 12 && d <= 14)) return `${x} zaległe potwierdzenia`;
    return `${x} zaległych potwierdzeń`;
};

/** Data DD.MM z ISO (krótko, jak w „do 3.10”); niepoprawna — pusty napis. */
export const dataKrotka = (iso) => {
    if (!iso) return "";
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return "";
    return `${d.getDate()}.${String(d.getMonth() + 1).padStart(2, "0")}`;
};
